import React from 'react';
import HomeComponent from './Home.component';

const HomeContainer = () => {
  return (
    <div>
      <HomeComponent />
    </div>
  );
};

export default HomeContainer;